import { Stack, Typography } from '@mui/material';
import Link from '../../../../../../components/link/Link';

const NoActiveSubscription = () => {
  const linkTo = '/pricing';
  return (
    <Stack spacing={4}>
      <Typography variant="body3" color="primaryDark.500">
        You have no active subscriptions.
      </Typography>
      <Link to={linkTo}>
        <Typography
          variant="body1"
          color="primaryLight.500"
          sx={{ textDecoration: 'underline', fontFamily: 'Gellix-Regular', fontSize: '1.25rem' }}
        >
          Pricing
        </Typography>
      </Link>
    </Stack>
  );
};

export default NoActiveSubscription;
